// Expenses.jsx
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { CSVLink } from 'react-csv';
axios.defaults.withCredentials = true;  // ADD THIS TO SEND COOKIES WITH REQUESTS

const API_BASE_URL = 'https://kigaawater.inkenya.co.ke/api';
const SERVER_URL = 'https://kigaawater.inkenya.co.ke';

const styles = {
    container: { maxWidth: '1000px', margin: '20px auto', padding: '20px', backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' },
    header: { color: '#007bff', borderBottom: '2px solid #eee', paddingBottom: '10px', marginBottom: '20px' },
    section: { marginBottom: '30px', padding: '15px', border: '1px solid #ddd', borderRadius: '6px', backgroundColor: '#f9f9f9' },
    sectionHeader: { color: '#333', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' },
    table: { width: '100%', borderCollapse: 'collapse', marginBottom: '20px', backgroundColor: '#fff' },
    th: { padding: '12px 15px', border: '1px solid #ddd', textAlign: 'left', backgroundColor: '#f1f1f1' },
    td: { padding: '12px 15px', border: '1px solid #eee', verticalAlign: 'middle' },
    input: { padding: '8px', border: '1px solid #ccc', borderRadius: '4px', width: '100%', boxSizing: 'border-box' },
    button: { padding: '10px 15px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', margin: '0 5px', transition: 'background-color 0.3s' },
    success: { backgroundColor: '#28a745', color: 'white' },
    error: { backgroundColor: '#dc3545', color: 'white' },
    primary: { backgroundColor: '#007bff', color: 'white' },
    secondary: { backgroundColor: '#6c757d', color: 'white' },
    status: { padding: '10px', marginTop: '15px', borderRadius: '4px', fontWeight: 'bold' },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
    },
    bulkModalContent: {
        backgroundColor: '#fff',
        padding: '30px',
        borderRadius: '8px',
        width: '500px',
        maxHeight: '90%',
        overflowY: 'auto',
        boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
        position: 'relative',
    },
    modalHeader: {
        marginBottom: '20px',
        fontSize: '1.5em',
        fontWeight: '700',
        color: '#007bff',
        borderBottom: '1px solid #eee',
        paddingBottom: '10px',
    },
    closeButtonSmall: {
        position: 'absolute',
        top: '10px',
        right: '10px',
        backgroundColor: 'transparent',
        border: 'none',
        fontSize: '1.5em',
        color: '#6c757d',
        cursor: 'pointer',
    },
    instructionsText: {
        marginBottom: '20px',
        padding: '10px',
        backgroundColor: '#f8f9fa',
        borderLeft: '4px solid #007bff',
        borderRadius: '4px',
        fontSize: '0.9em',
        lineHeight: '1.4',
    },
    downloadSection: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '15px',
        backgroundColor: '#e9ecef',
        borderRadius: '6px',
        marginBottom: '15px',
    },
    downloadText: { fontWeight: '600', color: '#333' },
    downloadButton: {
        padding: '8px 15px',
        backgroundColor: '#28a745',
        color: 'white',
        textDecoration: 'none',
        borderRadius: '4px',
        fontWeight: 'bold',
        transition: 'background-color 0.3s',
        display: 'inline-block',
    },
    uploadSection: {
        padding: '15px',
        backgroundColor: '#f1f1f1',
        borderRadius: '6px',
        marginBottom: '20px',
    },
    fileInput: {
        width: '100%',
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '6px',
        boxSizing: 'border-box',
        fontSize: '16px',
        marginTop: '10px',
        backgroundColor: '#fff',
    },
    modalFooter: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingTop: '10px',
        borderTop: '1px solid #eee',
    },
    submitButton: {
        width: 'auto',
        padding: '12px 20px',
        backgroundColor: '#28a745',
        color: 'white',
        border: 'none',
        borderRadius: '6px',
        fontSize: '16px',
        cursor: 'pointer',
        fontWeight: 'bold',
        transition: 'background-color 0.3s',
        marginTop: '15px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

};

const getTodayDate = () => new Date().toISOString().split('T')[0];

const readBlobError = (blob) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            try {
                const errorData = JSON.parse(reader.result);
                resolve(errorData.error || 'Unknown server error.');
            } catch (e) {
                reject('Server returned an unexpected error format.');
            }
        };
        reader.onerror = () => reject('Error reading response blob.');
        reader.readAsText(blob);
    });
};

// ──────────────────────────────────────────────────────────────
// BULK UPLOAD MODAL (Reused from CustomerBalances.jsx format)
// ──────────────────────────────────────────────────────────────
const BulkUploadModal = ({
  isOpen,
  onClose,
  type,
  headers,
  instructions,
  onUpload,
  styles,
}) => {
  const [file, setFile] = useState(null);
  const fileName = `${type.toLowerCase().replace(' ', '_')}_template.csv`;

  if (!isOpen) return null;

  const handleFileChange = e => setFile(e.target.files[0]);

  const handleUploadClick = () => {
    if (file) {
      onUpload(file);
      setFile(null);
    } else {
      alert('Please select a file to upload.');
    }
  };

  return (
    <div style={styles.modalOverlay}>
      <div style={styles.bulkModalContent}>
        <h3 style={styles.modalHeader}>Bulk Upload {type}</h3>
        <p style={styles.instructionsText}>
          <strong>Instructions:</strong> {instructions}
        </p>

        <div style={styles.downloadSection}>
          <span style={styles.downloadText}>1. Download Template:</span>
          <CSVLink
            data={[]}
            headers={headers}
            filename={fileName}
            style={styles.downloadButton}
          >
            Download Template (.csv)
          </CSVLink>
        </div>

        <div style={styles.uploadSection}>
          <span style={styles.downloadText}>2. Upload Filled File:</span>
          <input
            type="file"
            accept=".csv"
            onChange={handleFileChange}
            style={styles.fileInput}
          />
        </div>

        <div style={styles.modalFooter}>
          <button
            style={{
              ...styles.submitButton,
              backgroundColor: '#6c757d',
              marginRight: '10px',
              marginTop: 0,
            }}
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            style={{
              ...styles.submitButton,
              backgroundColor: file ? '#007bff' : '#adb5bd',
              marginTop: 0,
            }}
            onClick={handleUploadClick}
            disabled={!file}
          >
            Upload
          </button>
        </div>

        <button onClick={onClose} style={styles.closeButtonSmall}>
          ×
        </button>
      </div>
    </div>
  );
};

// TEMPLATE COLUMN DEFINITIONS FOR NEW BULK UPLOADS
const EXPENSE_TYPE_HEADERS = [
  { label: "Expense Name", key: "expense_name" },
  { label: "Financial Category ID", key: "financial_category_id" },
  { label: "Is Recurring (yes or no)", key: "is_recurring" },
  { label: "Frequency (daily, weekly, monthly, semi-annually, annually)", key: "frequency" },
  { label: "Default Amount", key: "amount" },
];

const EXPENSE_TRANSACTION_HEADERS = [
  { label: "Expense Name", key: "expense_name" },
  { label: "Date (YYYY-MM-DD)", key: "date" },
  { label: "Amount", key: "amount" },
  { label: "Reference Number", key: "reference_number" },
  { label: "Description", key: "description" },
];

// --------------------------------------------------
// PAYROLL MANAGER - (New Section: 2)
// --------------------------------------------------
const PayrollManager = () => {
    return (
        <div style={styles.section}>
            <h3 style={styles.sectionHeader}>2. Payroll Management (To be implemented)</h3>
            <p>This section will contain tools for managing payroll, employee salaries, and pay slips.</p>
        </div>
    );
};

// --------------------------------------------------
// EXPENSE MANAGER – BRAND NEW & FULLY WORKING
// --------------------------------------------------
const ExpenseManager = ({ reportStatusSetter }) => {
    const [expensesList, setExpensesList] = useState([]);
    const [recordedExpenses, setRecordedExpenses] = useState([]);
const [isLoading, setIsLoading] = useState(false); 
    const [expenses, setExpenses] = useState([]);
    const [financialCategories, setFinancialCategories] = useState([]);
    const [showNewExpenseForm, setShowNewExpenseForm] = useState(false);

    const [newExpenseType, setNewExpenseType] = useState({
        expense_name: '',
        financial_category_id: '',
        is_recurring: 'no',
        frequency: 'monthly',
        amount: ''
    });

    const [addExpense, setAddExpense] = useState({
        expense_name: '',
        date: getTodayDate(),
        amount: '',
        reference_number: '',
        description: ''
    });

    const [filterName, setFilterName] = useState('');
    const [filterCategory, setFilterCategory] = useState('all');
    const [filterRecurring, setFilterRecurring] = useState('all');
    const [searchRef, setSearchRef] = useState('');

    // NEW: States for bulk upload modals
    const [isExpenseTypeModalOpen, setIsExpenseTypeModalOpen] = useState(false);
    const [isExpenseTransactionModalOpen, setIsExpenseTransactionModalOpen] = useState(false);

    const getCategoryName = useCallback((expenseName) => {
        const type = expensesList.find(t => t.expense_name === expenseName);
        return type?.category_name || 'Uncategorized';
    }, [expensesList]);

    // NEW: States for paid expenses modal
    const [showPaidModal, setShowPaidModal] = useState(false);
    const [paidExpenses, setPaidExpenses] = useState([]);
    const [selectedYear, setSelectedYear] = useState('');
    const [selectedMonth, setSelectedMonth] = useState('');
    const [availablePeriods, setAvailablePeriods] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [editForm, setEditForm] = useState({});

    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const paidTotal = paidExpenses.reduce(
    (sum, exp) => sum + Number(exp.amount || 0),
    0
);

    const fetchData = useCallback(async () => {
    try {
        const [typesRes, recordedRes, categoriesRes, periodsRes] = await Promise.all([
            axios.get(`${API_BASE_URL}/expenses/types`),
            axios.get(`${API_BASE_URL}/expenses`),
            axios.get(`${API_BASE_URL}/expenses/categories`),
            axios.get(`${API_BASE_URL}/expenses/paid/periods`)
        ]);
        setExpensesList(typesRes.data);
        setRecordedExpenses(recordedRes.data);
        setFinancialCategories(categoriesRes.data);
        setAvailablePeriods(periodsRes.data);
    } catch (error) {
        reportStatusSetter({ message: 'Failed to load expenses.', type: 'error' });
    }
}, [reportStatusSetter]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleCreateExpenseType = async () => {
        if (!newExpenseType.expense_name.trim() || !newExpenseType.financial_category_id) {
            reportStatusSetter({ message: 'Expense name and Financial Category (Level 1) are required.', type: 'error' });
            return;
        }
        const isRecurring = newExpenseType.is_recurring === 'yes';
        const amountValue = parseFloat(newExpenseType.amount);
        try {
            const payload = {
                expense_name: newExpenseType.expense_name.trim(),
                financial_category_id: parseInt(newExpenseType.financial_category_id, 10),
                is_recurring: isRecurring,
                frequency: isRecurring ? newExpenseType.frequency : null,
                amount: isRecurring && !isNaN(amountValue) && amountValue > 0 ? amountValue : null
            };
            const response = await axios.post(`${API_BASE_URL}/expenses/types`, payload);
            setNewExpenseType({
                expense_name: '',
                financial_category_id: '',
                is_recurring: 'no',
                frequency: 'monthly',
                amount: ''
            });
            setShowNewExpenseForm(false);
            fetchData();
            reportStatusSetter({ message: `Expense type "${response.data.expense_name}" created!`, type: 'success' });
        } catch (error) {
            reportStatusSetter({ message: error.response?.data?.error || 'Failed to save expense type.', type: 'error' });
        }
    };

    const handleRecordExpense = async () => {
        if (!addExpense.expense_name || !addExpense.expense_name.trim() || !addExpense.amount) {
            reportStatusSetter({ message: 'Expense Type and Amount are required.', type: 'error' });
            return;
        }
        const amountValue = parseFloat(addExpense.amount);
        const payload = {
            expense_name: addExpense.expense_name.trim(),
            date: addExpense.date,
            amount: amountValue,
            reference_number: (addExpense.reference_number && addExpense.reference_number.trim()) || null,
            description: (addExpense.description && addExpense.description.trim()) || addExpense.expense_name.trim()
        };
        if (isNaN(payload.amount) || payload.amount <= 0) {
            reportStatusSetter({ message: 'Please enter a valid amount greater than zero.', type: 'error' });
            return;
        }
        try {
            await axios.post(`${API_BASE_URL}/expenses`, payload);
            setAddExpense(prev => ({
                ...prev,
                expense_name: '',
                amount: '',
                reference_number: '',
                description: ''
            }));
            fetchData();
            reportStatusSetter({ message: 'Expense recorded!', type: 'success' });
        } catch (error) {
            reportStatusSetter({
                message: error.response?.data?.error || 'Failed to record expense.',
                type: 'error'
            });
        }
    };

    // New: Pay Bill handler
    const handlePayBill = async (recordId) => {
        if (!window.confirm('Mark this expense as PAID? It will be removed from the list.')) return;

        try {
            await axios.put(`${API_BASE_URL}/expenses/pay/${recordId}`);
            fetchData(); // Refresh to remove paid expense
            reportStatusSetter({ message: 'Expense marked as paid!', type: 'success' });
        } catch (error) {
            reportStatusSetter({ message: 'Failed to mark as paid.', type: 'error' });
        }
    };

    // NEW: Bulk upload handler for expense types
    const handleExpenseTypeBulkUpload = async file => {
        const form = new FormData();
        form.append('file', file);

        try {
            const { data } = await axios.post(
                `${API_BASE_URL}/bulk-upload-expense-types`,
                form,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            reportStatusSetter({
                message: `Expense Types Upload: ${data.message}. Refreshing data...`,
                type: 'success'
            });
            await fetchData();
            setIsExpenseTypeModalOpen(false);
        } catch (err) {
            const msg = err.response?.data?.error || err.message;
            reportStatusSetter({ message: `Expense Types Upload Failed: ${msg}`, type: 'error' });
        }
    };

    // NEW: Bulk upload handler for expense transactions
    const handleExpenseTransactionBulkUpload = async file => {
        const form = new FormData();
        form.append('file', file);

        try {
            const { data } = await axios.post(
                `${API_BASE_URL}/bulk-upload-expenses`,
                form,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            reportStatusSetter({
                message: `Expense Transactions Upload: ${data.message}. Refreshing data...`,
                type: 'success'
            });
            await fetchData();
            setIsExpenseTransactionModalOpen(false);
        } catch (err) {
            const msg = err.response?.data?.error || err.message;
            reportStatusSetter({ message: `Expense Transactions Upload Failed: ${msg}`, type: 'error' });
        }
    };

    // NEW: Handlers for paid expenses
    const handleViewPaid = () => setShowPaidModal(true);

    const handlePeriodChange = async () => {
        if (selectedYear && selectedMonth) {
            try {
                const res = await axios.get(`${API_BASE_URL}/expenses/paid`, {
                    params: { year: selectedYear, month: selectedMonth }
                });
                setPaidExpenses(res.data);
            } catch (err) {
                reportStatusSetter({ message: 'Failed to load paid expenses.', type: 'error' });
            }
        }
    };

    useEffect(() => {
        if (showPaidModal && selectedYear && selectedMonth) {
            handlePeriodChange();
        }
    }, [selectedYear, selectedMonth, showPaidModal]);

    const startEdit = (exp) => {
        setEditingId(exp.record_id);
        setEditForm({
            expense_name: exp.expense_name,
            date: exp.date,
            amount: exp.amount,
            reference_number: exp.reference_number || '',
            description: exp.description
        });
    };

    const handleEditChange = (field, value) => {
        setEditForm(prev => ({ ...prev, [field]: value }));
    };

    const saveEdit = async (id) => {
        try {
            await axios.put(`${API_BASE_URL}/expenses/${id}`, editForm);
            handlePeriodChange();
            setEditingId(null);
            reportStatusSetter({ message: 'Expense updated!', type: 'success' });
        } catch (err) {
            reportStatusSetter({ message: 'Failed to update expense.', type: 'error' });
        }
    };

    const deletePaid = async (id) => {
        if (window.confirm('Delete this paid expense? This action cannot be undone.')) {
            try {
                await axios.delete(`${API_BASE_URL}/expenses/${id}`);
                handlePeriodChange();
                reportStatusSetter({ message: 'Expense deleted!', type: 'success' });
            } catch (err) {
                reportStatusSetter({ message: 'Failed to delete expense.', type: 'error' });
            }
        }
    };

// Expenses.jsx
const handlePayAll = async () => {
    if (!window.confirm("Mark all bills as paid? This will update the accounting ledger.")) return;
    setIsLoading(true);
    try {
        await axios.post(`${API_BASE_URL}/expenses/pay-all`);
        setRecordedExpenses(prev => prev.filter(exp => exp.is_paid === true)); 
        await fetchData();
        reportStatusSetter({ 
            type: 'success', 
            message: "All unpaid bills marked as paid and ledger updated." 
        });
    } catch (err) {
        console.error("Pay All Error:", err);
        reportStatusSetter({ 
            type: 'error', 
            message: err.response?.data?.error || "Error processing bulk payment." 
        });
        // On error, refresh anyway to show correct state
        await fetchData();
    } finally {
        setIsLoading(false);
    }
};

const handleDeleteAll = async () => {
    if (!window.confirm("WARNING: This will permanently delete ALL expense records. Proceed?")) return;

    setIsLoading(true);
    try {
        await axios.delete(`${API_BASE_URL}/expenses/delete-all`);

        setRecordedExpenses([]);

        await fetchData();

        reportStatusSetter({ 
            type: 'success', 
            message: "All expense records deleted successfully." 
        });
    } catch (err) {
        console.error("Delete Error:", err);
        reportStatusSetter({ 
            type: 'error', 
            message: err.response?.data?.error || "Error deleting expenses." 
        });
        await fetchData(); // Sync state even on error
    } finally {
        setIsLoading(false);
    }
};


    const filteredExpenses = recordedExpenses.filter(exp => {
        if (filterName && !exp.expense_name.toLowerCase().includes(filterName.toLowerCase())) return false;
        if (searchRef && !exp.reference_number?.toLowerCase().includes(searchRef.toLowerCase())) return false;
       
        const categoryName = getCategoryName(exp.expense_name);
        if (filterCategory !== 'all' && categoryName !== filterCategory) return false;
        const type = expensesList.find(t => t.expense_name === exp.expense_name);
        if (filterRecurring !== 'all') {
            if (!type) {
                if (filterRecurring === 'recurring') return false;
            } else {
                if (filterRecurring === 'recurring' && !type.is_recurring) return false;
                if (filterRecurring === 'non-recurring' && type.is_recurring) return false;
                if (['daily', 'weekly', 'monthly', 'semi-annually', 'annually'].includes(filterRecurring)) {
                    if (type.frequency !== filterRecurring) return false;
                }
            }
        }
        return true;
    });

    return (
        <div style={styles.section}>
            <h3 style={styles.sectionHeader}>1. Expense Management</h3>
            {/* 1. DEFINE NEW EXPENSE TYPE */}
            <div style={{ marginBottom: '40px', padding: '20px', backgroundColor: '#f0f8ff', borderRadius: '8px' }}>
                <h4 style={{ color: '#333', margin: '0 0 15px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    Define New Expense Type
                    {!showNewExpenseForm && (
                        <button onClick={() => setShowNewExpenseForm(true)} style={{ ...styles.button, ...styles.primary, fontSize: '14px' }}>
                            Add New Type
                        </button>
                    )}
                </h4>
                {/* NEW: Bulk upload button for expense types */}
                <button 
                    onClick={() => setIsExpenseTypeModalOpen(true)} 
                    style={{ ...styles.button, ...styles.primary, fontSize: '14px', marginLeft: '10px' }}
                >
                    Bulk Upload Types
                </button>
                {showNewExpenseForm && (
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                        <div>
                            <label>Expense Name (L2)</label>
                            <input style={styles.input} value={newExpenseType.expense_name} onChange={e => setNewExpenseType({ ...newExpenseType, expense_name: e.target.value })} />
                        </div>
                        <div>
                            <label>Financial Category (L1)</label>
                            <select style={styles.input} value={newExpenseType.financial_category_id} onChange={e => setNewExpenseType({ ...newExpenseType, financial_category_id: e.target.value })}>
                                <option value="">Select Category</option>
                                {financialCategories.map(cat => (
                                    <option key={cat.category_id} value={cat.category_id}>{cat.category_name}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label>Recurring?</label>
                            <div style={{ display: 'flex', gap: '20px', marginTop: '8px' }}>
                                <label><input type="radio" name="recurring" value="no" checked={newExpenseType.is_recurring === 'no'} onChange={e => setNewExpenseType({ ...newExpenseType, is_recurring: e.target.value })} /> No</label>
                                <label><input type="radio" name="recurring" value="yes" checked={newExpenseType.is_recurring === 'yes'} onChange={e => setNewExpenseType({ ...newExpenseType, is_recurring: e.target.value })} /> Yes</label>
                            </div>
                        </div>
                        {newExpenseType.is_recurring === 'yes' && (
                            <>
                                <div>
                                    <label>Frequency</label>
                                    <select style={styles.input} value={newExpenseType.frequency} onChange={e => setNewExpenseType({ ...newExpenseType, frequency: e.target.value })}>
                                        <option value="daily">Daily</option>
                                        <option value="weekly">Weekly</option>
                                        <option value="monthly">Monthly</option>
                                        <option value="semi-annually">Semi-Annually</option>
                                        <option value="annually">Annually</option>
                                    </select>
                                </div>
                                <div>
                                    <label>Default Amount</label>
                                    <input style={styles.input} type="number" value={newExpenseType.amount} onChange={e => setNewExpenseType({ ...newExpenseType, amount: e.target.value })} />
                                </div>
                            </>
                        )}
                        <div style={{ gridColumn: '1 / span 2', marginTop: '10px' }}>
                            <button style={{ ...styles.button, ...styles.success }} onClick={handleCreateExpenseType}>Save Type</button>
                            <button style={{ ...styles.button, ...styles.secondary, marginLeft: '10px' }} onClick={() => setShowNewExpenseForm(false)}>Cancel</button>
                        </div>
                    </div>
                )}
            </div>
            {/* 2. RECORD EXPENSE */}
            <div style={{ marginBottom: '40px', padding: '20px', backgroundColor: '#f8fff0', borderRadius: '8px' }}>
                <h4 style={{ color: '#333', marginBottom: '15px' }}>Record Expense Payment</h4>
                {/* NEW: Bulk upload button for expense transactions */}
                <button 
                    onClick={() => setIsExpenseTransactionModalOpen(true)} 
                    style={{ ...styles.button, ...styles.primary, fontSize: '14px', marginBottom: '15px' }}
                >
                    Bulk Upload Transactions
                </button>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '15px' }}>
                    <div>
                        <label>Expense Name</label>
                        <input style={styles.input} value={addExpense.expense_name} onChange={e => setAddExpense({ ...addExpense, expense_name: e.target.value })} list="expense-names" placeholder="Search or type..." />
                        <datalist id="expense-names">
                            {expensesList.map(ex => <option key={ex.expense_id} value={ex.expense_name} />)}
                            <option value="ADD_NEW_EXPENSE_TYPE">+ Add New Expense Type</option>
                        </datalist>
                        {addExpense.expense_name === 'ADD_NEW_EXPENSE_TYPE' && (
                            <div style={{ marginTop: '8px', color: '#0066cc', fontWeight: 'bold', cursor: 'pointer' }} onClick={() => {
                                setAddExpense({ ...addExpense, expense_name: '' });
                                setShowNewExpenseForm(true);
                            }}>
                                Click to add new expense type
                            </div>
                        )}
                    </div>
                    <div><label>Date</label><input style={styles.input} type="date" value={addExpense.date} onChange={e => setAddExpense({ ...addExpense, date: e.target.value })} /></div>
                    <div><label>Amount (Ksh)</label><input style={styles.input} type="number" value={addExpense.amount} onChange={e => setAddExpense({ ...addExpense, amount: e.target.value })} /></div>
                    <div><label>Reference (optional)</label><input style={styles.input} value={addExpense.reference_number} onChange={e => setAddExpense({ ...addExpense, reference_number: e.target.value })} /></div>
                </div>
                <button style={{ ...styles.button, ...styles.primary, marginTop: '15px' }} onClick={handleRecordExpense}>Record Expense</button>
            </div>
            {/* VIEW EXPENSES */}
            <div>
                <h4 style={{ color: '#333', marginBottom: '15px' }}>Unpaid Expenses ({filteredExpenses.length})</h4>
                               <button 
                    style={{ ...styles.button, ...styles.primary, marginLeft: '10px' }} 
                    onClick={handleViewPaid}
                >
                    View Paid Expenses
                </button>

                {/* NEW: Pay All and Delete All buttons */}
                <div style={{ marginBottom: '15px' }}>
                    <button 
                        style={{ ...styles.button, ...styles.success }} 
                        onClick={handlePayAll}
                    >
                        Pay All Unpaid
                    </button>
                    <button 
                        style={{ ...styles.button, ...styles.error, marginLeft: '10px' }} 
                        onClick={handleDeleteAll}
                    >
                        Delete All Unpaid
                    </button>
                </div>

                {/* Filters */}
                <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', alignItems: 'center', flexWrap: 'wrap', padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }}>
                    <input style={{ ...styles.input, width: '200px' }} placeholder="Filter by Name..." value={filterName} onChange={e => setFilterName(e.target.value)} />
                    <select style={{ ...styles.input, width: '200px' }} value={filterCategory} onChange={e => setFilterCategory(e.target.value)}>
                        <option value="all">All Categories</option>
                        <option value="Uncategorized">Uncategorized</option>
                        {financialCategories.map(cat => (
                            <option key={cat.category_id} value={cat.category_name}>{cat.category_name}</option>
                        ))}
                    </select>
                    <input style={{ ...styles.input, width: '150px' }} placeholder="Filter Ref..." value={searchRef} onChange={e => setSearchRef(e.target.value)} />
                    <select style={{ ...styles.input, width: '150px' }} value={filterRecurring} onChange={e => setFilterRecurring(e.target.value)}>
                        <option value="all">All Types</option>
                        <option value="recurring">Recurring</option>
                        <option value="non-recurring">Non-Recurring</option>
                    </select>
                </div>
                <table style={styles.table}>
                    <thead>
                        <tr>
                            <th style={styles.th}>Date</th>
                            <th style={styles.th}>P&L Category</th>
                            <th style={styles.th}>Expense Name</th>
                            <th style={styles.th}>Amount</th>
                            <th style={styles.th}>Reference</th>
                            <th style={styles.th}>Recurring?</th>
                            <th style={styles.th}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredExpenses.map(exp => {
                            const type = expensesList.find(t => t.expense_name === exp.expense_name);
                            const category = getCategoryName(exp.expense_name);
                            const recurringText = type?.is_recurring ? `Yes (${type.frequency})` : 'No';
                            return (
                                <tr key={exp.record_id}>
                                    <td style={styles.td}>{new Date(exp.date).toLocaleDateString()}</td>
                                    <td style={styles.td}>{category}</td>
                                    <td style={styles.td}>{exp.expense_name}</td>
                                    <td style={styles.td}>Ksh {parseFloat(exp.amount).toFixed(2)}</td>
                                    <td style={styles.td}>{exp.reference_number || '-'}</td>
                                    <td style={styles.td}>{recurringText}</td>
                                    <td style={styles.td}>
                                        <button 
                                            style={{ ...styles.button, ...styles.success, fontSize: '12px' }} 
                                            onClick={() => handlePayBill(exp.record_id)}
                                        >
                                            Pay Bill
                                        </button>
                                        <button style={{ ...styles.button, ...styles.error, fontSize: '12px' }} onClick={async () => {
                                            if (window.confirm('Delete this expense?')) {
                                                await axios.delete(`${API_BASE_URL}/expenses/${exp.record_id}`);
                                                fetchData();
                                                reportStatusSetter({ message: 'Deleted!', type: 'success' });
                                            }
                                        }}>Delete</button>
                                    </td>
                                </tr>
                            );
                        })}
                        {filteredExpenses.length === 0 && <tr><td colSpan="7" style={{ textAlign: 'center', padding: '30px', color: '#888' }}>No unpaid expenses match your filters</td></tr>}
                    </tbody>
                </table>
            </div>

            {/* NEW: Bulk Upload Modals */}
            <BulkUploadModal
                isOpen={isExpenseTypeModalOpen}
                onClose={() => setIsExpenseTypeModalOpen(false)}
                type="Expense Types"
                headers={EXPENSE_TYPE_HEADERS}
                instructions="Please fill the downloaded template with new expense types. Do not change the column headers. For 'Is Recurring', use 'yes' or 'no'. Leave 'Frequency' and 'Default Amount' blank for non-recurring types. Use valid Financial Category IDs from the system."
                onUpload={handleExpenseTypeBulkUpload}
                styles={styles}
            />

            <BulkUploadModal
                isOpen={isExpenseTransactionModalOpen}
                onClose={() => setIsExpenseTransactionModalOpen(false)}
                type="Expense Transactions"
                headers={EXPENSE_TRANSACTION_HEADERS}
                instructions="Fill the downloaded template with expense transactions. Use existing Expense Names. Description is optional (defaults to Expense Name if blank). Use YYYY-MM-DD for Date."
                onUpload={handleExpenseTransactionBulkUpload}
                styles={styles}
            />
            {/* NEW: Paid Expenses Modal */}
            {showPaidModal && (
                <div style={styles.modalOverlay}>
                    <div style={{ ...styles.bulkModalContent, width: '800px' }}>
                        <h3 style={styles.modalHeader}>Paid Expenses</h3>
                        <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                            <div
    style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px',
        gap: '15px',
        flexWrap: 'wrap'
    }}
>
    {/* Year + Month filters */}
    <div style={{ display: 'flex', gap: '10px' }}>
        <select
            value={selectedYear}
            onChange={e => {
                setSelectedYear(e.target.value);
                setSelectedMonth('');
                setPaidExpenses([]);
            }}
        >
            <option value="">Select Year</option>
            {[...new Set(availablePeriods.map(p => p.year))]
                .sort((a, b) => b - a)
                .map(y => (
                    <option key={y} value={y}>{y}</option>
                ))}
        </select>

        <select
            value={selectedMonth}
            onChange={e => setSelectedMonth(e.target.value)}
            disabled={!selectedYear}
        >
            <option value="">Select Month</option>
            {selectedYear && availablePeriods
                .filter(p => Number(p.year) === Number(selectedYear))
                .map(p => Number(p.month))
                .sort((a, b) => a - b)
                .map(m => (
                    <option key={m} value={m}>
                        {monthNames[m - 1]}
                    </option>
                ))}
        </select>
    </div>

    {/* Total + Print */}
    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        <strong>
            Total: Ksh {paidTotal.toLocaleString(undefined, { minimumFractionDigits: 2 })}
        </strong>

        <button
            onClick={() => window.print()}
            style={{ ...styles.button, ...styles.primary, fontSize: '14px' }}
        >
            Print
        </button>
    </div>
</div>


                        </div>
                        {selectedYear && selectedMonth ? (
                            <table style={styles.table}>
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>P&L Category</th>
                                        <th>Expense Name</th>
                                        <th>Amount</th>
                                        <th>Reference</th>
                                        <th>Description</th>
                                        <th className="no-print">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paidExpenses.map(exp => {
                                        const category = getCategoryName(exp.expense_name);
                                        return (
                                            <tr key={exp.record_id}>
                                                {editingId === exp.record_id ? (
                                                    <>
                                                        <td><input type="date" value={editForm.date} onChange={e => handleEditChange('date', e.target.value)} /></td>
                                                        <td>{category}</td>
                                                        <td><input value={editForm.expense_name} onChange={e => handleEditChange('expense_name', e.target.value)} /></td>
                                                        <td><input type="number" value={editForm.amount} onChange={e => handleEditChange('amount', e.target.value)} /></td>
                                                        <td><input value={editForm.reference_number} onChange={e => handleEditChange('reference_number', e.target.value)} /></td>
                                                        <td><input value={editForm.description} onChange={e => handleEditChange('description', e.target.value)} /></td>
                                                        <td>
                                                            <button style={{ ...styles.button, ...styles.success, fontSize: '12px' }} onClick={() => saveEdit(exp.record_id)}>Save</button>
                                                            <button style={{ ...styles.button, ...styles.secondary, fontSize: '12px' }} onClick={() => setEditingId(null)}>Cancel</button>
                                                        </td>
                                                    </>
                                                ) : (
                                                    <>
                                                        <td>{new Date(exp.date).toLocaleDateString()}</td>
                                                        <td>{category}</td>
                                                        <td>{exp.expense_name}</td>
                                                        <td>Ksh {parseFloat(exp.amount).toFixed(2)}</td>
                                                        <td>{exp.reference_number || '-'}</td>
                                                        <td>{exp.description}</td>
                                                        <td>
                                                            <button style={{ ...styles.button, ...styles.primary, fontSize: '12px' }} onClick={() => startEdit(exp)}>Edit</button>
                                                            <button style={{ ...styles.button, ...styles.error, fontSize: '12px' }} onClick={() => deletePaid(exp.record_id)}>Delete</button>
                                                        </td>
                                                    </>
                                                )}
                                            </tr>
                                        );
                                    })}
                                    {paidExpenses.length === 0 && <tr><td colSpan="7" style={{ textAlign: 'center' }}>No paid expenses for this period.</td></tr>}
                                </tbody>
                            </table>
                        ) : (
                            <p style={{ textAlign: 'center', color: '#666' }}>Please select a year and month to view paid expenses.</p>
                        )}
                        <button onClick={() => setShowPaidModal(false)} style={styles.closeButtonSmall}>×</button>
                    </div>
                </div>
            )}

        </div>
    );
};

// --------------------------------------------------
// P&L REPORT MANAGER COMPONENT (Section 5)
// --------------------------------------------------
const PnlReportManager = ({ reportStatusSetter }) => {
    const [dates, setDates] = useState({
        start_date: getTodayDate().substring(0, 8) + '01',
        end_date: getTodayDate()
    });
    const [isLoading, setIsLoading] = useState(false);

    const handleDownloadPnl = async () => {
        if (!dates.start_date || !dates.end_date) {
            reportStatusSetter({ message: 'Both Start Date and End Date are required.', type: 'error' });
            return;
        }
        setIsLoading(true);
        reportStatusSetter(null);
        try {
            const response = await axios.get(
                `${API_BASE_URL}/reports/pnl-pdf`,
                {
                    params: dates,
                    responseType: 'blob',
                }
            );

            if (response.data.size < 50) {
                 throw new Error("Received an unexpectedly small file, potential server issue or empty report.");
            }

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `pnl_report_${dates.start_date}_to_${dates.end_date}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);

            reportStatusSetter({ message: 'P&L Report downloaded successfully! (Check your Downloads folder)', type: 'success' });

        } catch (error) {
            console.error("P&L Download Error:", error);
            let errorMsg = 'Failed to download P&L report.';

            if (error.response && error.response.data instanceof Blob) {
                try {
                    errorMsg = await readBlobError(error.response.data);
                } catch (readError) {
                    errorMsg = readError;
                }
            } else if (error.message) {
                errorMsg = error.message;
            } else if (error.response?.data?.error) {
                errorMsg = error.response.data.error;
            }
           
            reportStatusSetter({ message: errorMsg, type: 'error' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={styles.section}>
            <h3 style={styles.sectionHeader}>3. Profit & Loss (P&L) Report Download</h3>
            <div style={{ padding: '20px', backgroundColor: '#f0faff', borderRadius: '8px' }}>
                <h4 style={{ color: '#333', marginBottom: '15px' }}>Download P&L Statement (PDF)</h4>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: '15px', alignItems: 'flex-end' }}>
                    <div>
                        <label>Start Date</label>
                        <input
                            style={styles.input}
                            type="date"
                            value={dates.start_date}
                            onChange={e => setDates({ ...dates, start_date: e.target.value })}
                        />
                    </div>
                    <div>
                        <label>End Date</label>
                        <input
                            style={styles.input}
                            type="date"
                            value={dates.end_date}
                            onChange={e => setDates({ ...dates, end_date: e.target.value })}
                        />
                    </div>
                    <button
                        style={{ ...styles.button, ...styles.primary, minWidth: '150px', height: '38px' }}
                        onClick={handleDownloadPnl}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Generating...' : 'Download P&L PDF'}
                    </button>
                </div>
            </div>
        </div>
    );
};

// --------------------------------------------------
// MAIN Expenses Component
// --------------------------------------------------
function Expenses() {
    const [reportStatus, setReportStatus] = useState(null);

    const renderStatus = (status) => {
        if (!status) return null;
        const s = status.type === 'success'
            ? { backgroundColor: '#d4edda', color: '#155724' }
            : { backgroundColor: '#f8d7da', color: '#721c24' };
        return <div style={{ ...styles.status, ...s }}>{status.message}</div>;
    };

    return (
        <div style={styles.container}>
            <h2 style={styles.header}>Expenses and Payroll (3.7)</h2>
            <ExpenseManager reportStatusSetter={setReportStatus} />
            <PayrollManager reportStatusSetter={setReportStatus} />
            <PnlReportManager reportStatusSetter={setReportStatus} />
            {renderStatus(reportStatus)}
        </div>
    );
}
<style>
{`
@media print {
    .no-print {
        display: none !important;
    }

    button {
        display: none !important;
    }

    select {
        display: none !important;
    }

    body {
        background: white;
    }
}
`}
</style>

export default Expenses;